import { eWebinarHTMLForm } from './eWebinarHTMLForm';
import { eWebinarScript } from './eWebinarScript';
import './style.css';

export const SBEWebinarForm = () => (
  <div
    id="webinar-form"
    className="bg-naturaily-vulcan scroll-mt-10 px-4 py-12 text-white md:scroll-m-12 lg:scroll-mt-16 lg:rounded-2xl lg:p-8 xl:scroll-mt-20"
  >
    <div id="script" dangerouslySetInnerHTML={{ __html: eWebinarHTMLForm }} />
    <div id="script" dangerouslySetInnerHTML={{ __html: eWebinarScript }} />
  </div>
);
